var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h8M8 11h8M8 15h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.28cec31738b680b8d256e52b4307c0b1.svg";
export { ForwardRef as ReactComponent };